<template lang="html">
  <div class="modal-wrapper groups">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      {{modalData.title}}
    </div>
    <div class="inputs">
      <span>izaberite grupu:</span>
      <dropdown
        :defaultText="'grupe'"
        :selected="selected"
        :list="groups"
        @changeOption="selected = $event"
      />
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        ok
      </div>
      <div @click="closeModal()" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/dropdown.vue'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'ChangeGroupModal',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  components: {
    Dropdown
  },
  data () {
    return {
      groups: [],
      selected: null
    }
  },
  mounted () {
    this.getGroups()
  },
  methods: {
    getGroups () {
      api.getGroupsAll().then(res => {
        console.log(res)
        for (var i = 0; i < res.data.data.length; i++) {
          let obj = {
            label: res.data.data[i].grp_name,
            value: res.data.data[i].grp_id
          }
          this.groups.push(obj)
        }
        let obj = {
          label: 'Izbaci',
          value: 'delete'
        }
        this.groups.push(obj)
      }).catch(e => {
        console.log(e)
      }).then(() => {
        this.setActiveGroup()
      })
    },
    setActiveGroup () {
      if (this.modalData.group) {
        for (var i = 0; i < this.groups.length; i++) {
          if (this.groups[i].value === this.modalData.group) {
            this.selected = this.groups[i]
          }
        }
      }
    },
    ok () {
      this.modalData.ok(this.selected.value)
      eventBus.$emit('closeModal')
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .dropdown-wrapper {
    width: 200px;
  }

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 220px;
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
